module.exports = __webpack_public_path__ + "static/media/tilde.ca609f3a.svg";